interface IInFlightRequest {
  key: string
  promise: Promise<unknown>
}

const latestRequestByChannel = new Map<string, IInFlightRequest>()

export const buildRequestKey = (...parts: unknown[]): string => JSON.stringify(parts)

export const dedupeInFlight = (
  channel: string,
  key: string,
  request: () => unknown,
): Promise<unknown> => {
  const latest = latestRequestByChannel.get(channel)
  if (latest?.key === key) {
    return latest.promise
  }
  const promise: Promise<unknown> = Promise.resolve(request()).finally(() => {
    if (latestRequestByChannel.get(channel)?.promise === promise) {
      latestRequestByChannel.delete(channel)
    }
  })
  latestRequestByChannel.set(channel, { key, promise })
  return promise
}
